import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { CommonModule } from '@angular/common';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-user-attendance-view',
  templateUrl: './user-attendance-view.component.html',
  styleUrl: './user-attendance-view.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class UserAttendanceViewComponent implements OnInit {
  public id: any;
  attendanceRequest: any;
  filteredAttendanceData: any;
  showSpinner: any;
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  Admin_detail: any;

  constructor(
    private attendanceService: AttendanceService,
    public router: Router,
    private _location: Location,
    private route: ActivatedRoute,
    public dashboardService: DashboardService,

    private sharedmode: SharedModeService,
    // private dataSharingService: DataSharingService,


  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');

    this.id = this.route.snapshot.params['id'];
    // this.user_detail();

  }
  ngOnInit(): void {
    this.getAttendanceData(this.id);
  }
  detailAdmin(data: any) {
    this.Admin_detail = data

  }
  getAttendanceData(id: any) {
    this.showSpinner = true;
    this.attendanceService.getattendancerequest(id).then((value) => {
      this.attendanceRequest = value?.data;
      this.showSpinner = false;
    });
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }


}
